import React, { useState, useEffect, useContext, useCallback } from "react";
import DataTable from "react-data-table-component";
import LinearProgress from "@mui/material/LinearProgress";
import { ActionContext } from "context/ActionContext";
import useActionTable from "./useActionTable.js";
import { compte } from "variables/patrimoine.js";

const RTMetersContracts = () => {
  const { gridState, refreshTable } = useActionTable();
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;

  let energy = "electricity";
  let parameters = "meters";

  const columns = [
    {
      name: compte.energy[energy][parameters].meternumber,
      selector: (row) => row.meternumber,
      sortable: true,
    },
    {
      name: compte.energy[energy][parameters].associatedcontractid,
      selector: (row) =>
        action.parameters?.impact?.associatedContracts?.find(
          (c) => c.uuid == row.details.associatedcontractid
        )?.details?.contractname ?? "",
      sortable: true,
    },
    {
      name: "Nouveau contrat",
      selector: (row) =>
        action.parameters?.impact?.newContract?.find(
          (c) => c.uuid == row.details.newContract
        )?.details?.contractname ?? "",
      sortable: true,
    },
  ];

  const contextMessage = {
    singular: "compteur",
    plural: "compteurs",
    message: "sélectionné(s)",
  };

  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noDataComponent="Aucun compteur sélectionné"
        subHeader
        columns={columns}
        persistTableHead
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        highlightOnHover
        dense
        contextMessage={contextMessage}
        pagination
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les compteurs",
        }}
        {...gridState}
      />
    </>
  );
};

export default RTMetersContracts;
